/**
 * 需求（应用领域 / 需求类型）选项词表
 *
 * 《需求采集表》、个人中心需求编辑、后台需求编辑三处曾各自维护一份，
 * 而个人中心用的是另一套完全不同的技术领域词表（新一代信息技术、人工智能…），
 * 于是同一条需求在采集表和编辑弹窗里显示的应用领域对不上，保存一次就会被改写。
 * 三处统一从这里取，避免再次出现词表分裂。
 */

// 战略性新兴产业
export const emergingIndustries = [
  '节能环保产业', '新一代信息技术产业', '高端装备制造产业', '新能源产业',
  '新材料产业', '生物产业', '新能源汽车产业', '数字创意产业'
]

// 传统产业
export const traditionalIndustries = [
  '农、林、牧、渔业', '采矿业', '制造业', '水利环境', '教育，医疗卫生',
  '文化、体育和娱乐', '电力、热力和燃气', '建筑业', '交通运输和仓储',
  '住宿和餐饮业', '信息传输、软件和信息技术服务业', '金融业',
  '房地产业', '新能源', '科学研究和技术服务'
]

// 需求类型（单选，「其他」时需填写具体内容）
export const demandTypeOptions = ['技术需求', '金融需求', '场景需求', '其他']
